var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.renderable_blocks.length)?_c('div',{staticClass:"cms-blocks"},_vm._l((_vm.renderable_blocks),function(block){return _c(block.component,_vm._b({key:`cms-block-${block.type}-${block.index}`,tag:"component"},'component',block.props,false))}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }